import { Link } from "react-router-dom";
import { LEGAL } from "@/legal/config";

const links = [["/privacy", "Privacy"], ["/terms", "Terms"], ["/support", "Support"]];

export const LegalLayout = ({ title, subtitle, testId, children }) => (
  <div className="min-h-screen bg-background" data-testid={testId}>
    <header className="border-b border-border bg-card">
      <div className="max-w-3xl mx-auto px-4 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2" data-testid="legal-home-link">
          <img src="/logo-wordmark.png" alt={LEGAL.appName} className="h-12 w-auto" />
        </Link>
        <nav className="flex items-center gap-1 text-sm font-semibold">
          {links.map(([to, label]) => (
            <Link key={to} to={to} className="px-3 py-1.5 rounded-lg hover:bg-secondary text-slate-600 dark:text-slate-300" data-testid={`legal-nav-${label.toLowerCase()}`}>{label}</Link>
          ))}
        </nav>
      </div>
    </header>
    <main className="max-w-3xl mx-auto px-4 py-10 sm:py-14">
      <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight">{title}</h1>
      {subtitle && <p className="text-sm text-muted-foreground mt-2">{subtitle}</p>}
      <div className="mt-8 space-y-8 text-[15px] leading-relaxed [&_h2]:font-heading [&_h2]:text-xl [&_h2]:font-bold [&_h2]:mb-2 [&_p]:text-slate-700 dark:[&_p]:text-slate-300 [&_li]:text-slate-700 dark:[&_li]:text-slate-300 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1 [&_a]:text-emerald-700 [&_a]:font-semibold">
        {children}
      </div>
    </main>
    <footer className="border-t border-border py-8 text-center text-xs text-muted-foreground">
      © {new Date().getFullYear()} {LEGAL.appName} · {LEGAL.ownerName} · <a href={`mailto:${LEGAL.supportEmail}`} className="underline">{LEGAL.supportEmail}</a>
    </footer>
  </div>
);
